import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./css/navbar.css";
import { NavLink, useLocation } from "react-router-dom";
import image from "./media/result.svg";

export default function Navbar() {
  const location = useLocation();
  
  // Instead of multiple state variables, use a single object to track active pages
  const [activePages, setActivePages] = useState({});
  
  // Consolidate dropdown states into a single object
  const [dropdowns, setDropdowns] = useState({
    portfolio: false,
    services: false,
    product: false
  });
  
  // Mobile menu state
  const [isOpen, setIsOpen] = useState(false);

  // Toggle dropdown function that works for any dropdown
  const toggleDropdown = (dropdown) => {
    setDropdowns(prev => ({
      ...prev,
      [dropdown]: !prev[dropdown]
    }));
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Check if current page has white background
  const hasWhiteBackground = Object.values(activePages).some(isActive => isActive);

  useEffect(() => {
    // Update active pages based on current path
    setActivePages({
      getQuote: location.pathname === "/solar-quote",
      residential: location.pathname === "/residential",
      commercial: location.pathname === "/commercial",
      adu: location.pathname === "/adu",
      design: location.pathname === "/design",
      about: location.pathname === "/about",
      solar: location.pathname === "/solar-panels",
      battery: location.pathname === "/battery-storage",
      maintenance: location.pathname === "/maintenance",
      refer: location.pathname === "/refer-and-earn",
      upgrade: location.pathname === "/panel-upgrade",
    });

    // Close all dropdowns when navigating
    setDropdowns({
      portfolio: false,
      services: false,
      product: false
    });
  }, [location]);

  // Navigation items data structure for DRY code
  const dropdownMenus = {
    portfolio: [
      { to: "/residential", label: "Residential" },
      { to: "/commercial", label: "Commercial" },
      { to: "/adu", label: "ADU" }
    ],
    services: [
      { to: "/design", label: "Design & Installation" },
      { to: "/maintenance", label: "Maintenance" },
      { to: "/panel-upgrade", label: "Panel Upgrades" },
    ]
  };

  // Mobile navigation links
  const mobileLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/solar-quote", label: "Get Quote" },
    { to: "/residential", label: "Residential" },
    { to: "/commercial", label: "Commercial" },
    { to: "/adu", label: "ADU" },
    { to: "/design", label: "Design & Installation" },
    { to: "/maintenance", label: "Maintenance" },
    { to: "/refer-and-earn", label: "Refer & Earn" },
    { to: "/panel-upgrade", label: "Panel Upgrades" },
  ];

  return (
    <div className="parent-container">
      {/* Desktop Navigation */}
      <div className="desktop-nav-container"> 
        <nav className="navbar navbar-expand-lg navbar-light">
          <NavLink to="/">
            <img className="nav-logo" src={image} alt="logo" />
          </NavLink>

          <div className={hasWhiteBackground ? "internal-container white-background" : "internal-container"}>
            <ul className="links">
              {/* Portfolio Dropdown */}
              <li className="dropdown">
                <span className="dropbtn" onClick={() => toggleDropdown('portfolio')}>
                  Portfolio
                  <span className="arrow"></span>
                </span>
                {dropdowns.portfolio && (
                  <div className="dropdown-content show">
                    {dropdownMenus.portfolio.map((item) => (
                      <NavLink 
                        key={item.to}
                        className="dropdown-item"
                        to={item.to} 
                        onClick={() => toggleDropdown('portfolio')}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </li>

              {/* Services Dropdown */}
              <li className="dropdown">
                <span className="dropbtn" onClick={() => toggleDropdown('services')}>
                  Services
                  <span className="arrow"></span>
                </span>
                {dropdowns.services && (
                  <div className="dropdown-content show">
                    {dropdownMenus.services.map((item) => (
                      <NavLink 
                        key={item.to}
                        className="dropdown-item"
                        to={item.to} 
                        onClick={() => toggleDropdown('services')}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </li>

              <li className="maintenance-link">
                <NavLink to="/about">
                  About
                </NavLink>
              </li>

              <li className="refer-link">
                <NavLink to="/refer-and-earn">
                  Refer & Earn
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/solar-quote">
                  Request Quote
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      {/* Mobile Navigation */}
      <div className="mobile-nav-container">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="nav-logo-container">
            <NavLink to="/">
              <img className="nav-logo-mobile" src={image} alt="logo" />
            </NavLink>
          </div>

          <div 
            className={`hamburger-menu ${isOpen ? 'open' : ''} ${hasWhiteBackground ? 'white-background' : ''}`}
            onClick={toggleMenu}
          >
            <div></div>
            <div></div>
            <div></div>
          </div>

          <div className={isOpen ? "slide-in" : "slide-out"}>
            <ul className="mobile-nav" onClick={() => setIsOpen(false)}>
              {mobileLinks.map((link) => (
                <li key={link.to}>
                  <NavLink className="nav-link" to={link.to}>
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div> 
        </nav>
      </div>
    </div>
  );
}